angular.module('rjmNg.common.services').factory "notification", [
  "$timeout"
  ($timeout) ->
    queue = { }
    queue['global'] = []

    _removeNotification = (notification, notificationScope) ->
      queue[notificationScope]?.splice(queue[notificationScope]?.indexOf(notification), 1)

    _addNotification = (type, title, content, notificationScope, options, dismissInSeconds) ->
      notification =
        type: type
        title: title
        content: content
        notificationScope: notificationScope
        options: options

      # create a new queue for this notification scope if one hasn't been defined yet
      queue[notificationScope] ?= []

      queue[notificationScope].push notification
      if dismissInSeconds
        $timeout () ->
          _removeNotification notification, notificationScope
        , dismissInSeconds * 1000
      return notification

    info: (title, content, notificationScope, options = {}, dismissInSeconds = false) ->
      return _addNotification('info', title, content, notificationScope, options, dismissInSeconds)

    error: (title, content, notificationScope, options = {}, dismissInSeconds = false) ->
      return _addNotification('error', title, content, notificationScope, options, dismissInSeconds)

    success: (title, content, notificationScope, options = {}, dismissInSeconds = false) ->
      return _addNotification('success', title, content, notificationScope, options, dismissInSeconds)

    warning: (title, content, notificationScope, options = {}, dismissInSeconds = false) ->
      return _addNotification('warning', title, content, notificationScope, options, dismissInSeconds)

    clear: (notificationScope = 'global') ->
      queue[notificationScope]?.length = 0
      if queue[notificationScope]? then return queue[notificationScope]
      else return null

    clearAll: ->
      for k of queue
        queue[k].length = 0
      return queue

    clearById: (scope, id) ->
      scopeQueue = queue[scope]
      return unless scopeQueue?.length > 0
      matchingIndices = [0...scopeQueue.length].filter (index) ->
        scopeQueue[index].id is id
      while matchingIndices.length > 0
        index = matchingIndices.pop()
        scopeQueue.splice(index, 1)

    createQueue: (notificationScope = 'global') ->
      # create a new empty queue for this scope if one hasn't been defined yet
      queue[notificationScope] ?= []
      return queue[notificationScope]

    getQueue: (notificationScope = 'global') ->
      if queue[notificationScope]? then return queue[notificationScope]
      else return null

    remove: (notification, notificationScope = 'global') ->
      _removeNotification notification, notificationScope
]
